import React from "react";

export default function CustomTick(props) {
  const { x, y, payload } = props;

  const screenWidth = window.innerWidth;
  let dyValue = 10; 

  if (screenWidth > 768) {
    dyValue = payload.orientation === "top" ? -20 : 20;
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={dyValue}
        dx={-30}
        textAnchor="middle"
        fill="#fff"
        transform="rotate(-45)"
        className="customXTick"
        dominantBaseline="middle"
      >
        {payload.value}
      </text>
    </g>
  );
}
